import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from 'prototypes/securedCard/app.module.scss';
import AppChrome from 'prototypes/securedCard/components/AppChrome';
import PaycheckStack from 'prototypes/securedCard/components/PaycheckStack';
import StepFooter from 'prototypes/securedCard/components/StepFooter';
import { formatMoney } from 'prototypes/securedCard/formatMoney';
import { PrototypePath } from 'prototypes/securedCard/paths';
import { SAVINGS_APY_LABEL, SPENDABLE_PERCENT } from 'prototypes/securedCard/prototypeAssumptions';
import { cadencePhrase } from 'prototypes/securedCard/storyMath';
import { useStory } from 'prototypes/securedCard/StoryContext';

const GrowthStep = () => {
  const navigate = useNavigate();
  const { state, projection, setPaycheckCount, confirmGrowth } = useStory();

  return (
    <AppChrome
      step={PrototypePath.Growth}
      title="The card gets bigger because the savings do"
      subtitle={`Payroll keeps depositing ${formatMoney(state.perPaycheckCents)} ${cadencePhrase(
        state.cadence,
      )}. You don't transfer anything. Each payday adds about ${formatMoney(
        projection.paychecks[0].availableCents,
      )} to the card.`}
    >
      <div className={styles.stack}>
        <PaycheckStack paychecks={projection.paychecks} count={state.paycheckCount} onCount={setPaycheckCount} />
        <div className={styles.figureList}>
          <div className={styles.figure}>
            <div>
              <p className={styles.figureLabel}>Saved so far</p>
              <p className={styles.figureHint}>Paychecks only. Interest is listed beside this.</p>
            </div>
            <p className={styles.figureValue}>{formatMoney(projection.savingsCents)}</p>
          </div>
          <div className={`${styles.figure} ${styles.figurePrimary}`}>
            <div>
              <p className={styles.figureLabel}>Available on the card</p>
              <p className={styles.figureHint}>{SPENDABLE_PERCENT}% of what you've saved</p>
            </div>
            <p className={styles.figureValue}>{formatMoney(projection.availableCents)}</p>
          </div>
          <div className={styles.figure}>
            <div>
              <p className={styles.figureLabel}>Interest so far</p>
              <p className={styles.figureHint}>{SAVINGS_APY_LABEL} on the full savings</p>
            </div>
            <p className={styles.figureValue}>{formatMoney(projection.interestCents)}</p>
          </div>
        </div>
        <div className={`${styles.callout} ${styles.calloutPurple}`}>
          <p className={styles.calloutTitle}>This is the product</p>
          <p className={styles.calloutBody}>
            The money stays yours. Sending the paycheck here is how you save, and how the card limit grows, without a
            second process.
          </p>
        </div>
      </div>
      <StepFooter
        backTo={PrototypePath.Paycheck}
        nextLabel="Use the card"
        onNext={() => {
          confirmGrowth();
          navigate(PrototypePath.Spend);
        }}
      />
    </AppChrome>
  );
};

export default GrowthStep;
